import React, { useMemo } from 'react';
import {
  useLocation,
  useNavigate,
  useSearchParams,
  useParams,
  Location,
} from 'react-router-dom';
import getFirstNode from 'utils/getFirstNode';
import { GetRegion } from 'constants.js';

const NavigationWrapper = ({ children }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const params = useParams();

  const firstNodes = ['homeuser_lite', 'homeuser_kids', 'homeuser']
  const firstNode = getFirstNode();

  const queryParams = useMemo(
    () => {
      const currentLocation = location.pathname.split('/').at(-1)
      if (firstNodes.some((element) => element === currentLocation) &&
      firstNode !== currentLocation) {
        navigate(`/${GetRegion()}/${firstNode}`, { replace: true });
      } else {
        const objectOfParams = {};
        for (const entry of searchParams.entries()) {
          const [param, value] = entry;
          objectOfParams[param] = value;
        }
        return objectOfParams;
      }
    },
    [location.search, location.pathname],
  );

  return (
    <>
      {React.cloneElement(children, {
        location,
        queryParams,
        params,
        navigate,
        searchQuery: queryParams,
      })}
    </>
  );
};

export default NavigationWrapper;
